module.exports = __webpack_public_path__ + "img/2.f892f945.png";